import { render, staticRenderFns } from "./ScheduleCard.vue?vue&type=template&id=2126af1e&scoped=true&"
import script from "./ScheduleCard.vue?vue&type=script&lang=js&"
export * from "./ScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleCard.vue?vue&type=style&index=0&id=2126af1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126af1e",
  null
  
)

export default component.exports